<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :count='count'
      :current='page' :disablePage='disablePage'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>开票时间:</label>
            <timeStampDatePicker type='daterange' placeholder="请选择" class="item"
              v-model.trim='query.invoiceTimeRange' clearable></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>发票号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.invoiceCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>业务单据号:</label>
            <lk-input :maxlength='100' placeholder='请输入（支持后5位精准查询）' class="item" clearable
              v-model.trim='query.orderCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select class="item" clearable v-model.trim='query.status'>
              <lk-option v-for="item in statuslist" :key="item.id" :value='item.id'>{{item.name}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          </div>
          <div class="queryItem">
            <label>患者姓名:</label>
            <lk-input :maxlength='100' class="item" clearable placeholder='请输入'
              v-model.trim='query.patientName'></lk-input>
          </div>
          <div class="queryItem">
            <label>发票类型:</label>
            <lk-select v-model='query.invoiceType' class="item" placeholder="请选择" clearable>
              <lk-option v-for="(item,i) in invoiceTypeList" :key="i" :value='i'>{{item}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click="$router.push({name:'invoiceAdd'})"
            v-if="handlePermission('invoiceAdd')">
            +新建开票
          </lk-button>
          <lk-button :disabled='!invoiceFinishIds.length' @click="handleFinish" v-if="handlePermission('invoiceFinish')">完结</lk-button>
             <DownloadButton  @on-click="handleExport" v-if="handlePermission('invoiceExcel')"></DownloadButton>
        </div>
        <lk-table class="cancelTableShadow" border :columns='columns' :data='tableData'
          @on-selection-change='getSelected'></lk-table>
        <DTPModal v-model="finishModal" content='发票完结后将不可更改，请确认是否执行？' @confirm='confirmFinish'
          @handleCancel='cancelFinish' confirmText='执行' type='alert'>
        </DTPModal>
      </div>

    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DTPModal from '../../components/DTPModal.vue';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'invoice',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DTPModal,
    DownloadButton,
  },
  computed: {
    roleType() {
      return this.$store.state.user.roleType;
    },
  },
  data() {
    return {
      invoiceTypeList: {
        1: '增值税普通发票',
        2: '增值税电子发票',
      },
      finishModal: false,
      // belongStoreList:[],
      disablePage: false,
      supplierIds: [],
      statuslist: [{ id: 1, name: '未完结' }, { id: 2, name: '已完结' }],
      suppliers: [],
      params: {},
      query: {
        invoiceTimeRange: [],
        invoiceCode: '',
        orderCode: '',
        status: '',
        nameMix: '',
      },
      invoiceFinishIds: [],
      invoiceFinishedIds: [],
      subcolumns: [
        {
          title: '通用名', key: 'goodsInfoVoApprovedDrugName', minWidth: 116, tooltip: true,
        },
        {
          title: '规格', key: 'goodsInfoVoSpec', minWidth: 116, tooltip: true,
        },
        { title: '包装单位', key: 'goodsInfoVoDrugMiniPackageUnitString', minWidth: 116 },
        { title: '销售实价', key: 'financeInvoiceDetailPrice', minWidth: 110 },
        { title: '数量', key: 'financeInvoiceDetailNum', minWidth: 100 },
        { title: '含税金额', key: 'financeInvoiceDetailAmount', minWidth: 116 },
        { title: '税率', key: 'financeInvoiceDetailOutputTaxRate', minWidth: 116 },
        { title: '不含税金额', key: 'financeInvoiceDetailAmountWithoutTax', minWidth: 116 },
        { title: '税额', key: 'financeInvoiceDetailTotalTax', minWidth: 116 },

        { title: '是否DTP', key: 'isDtp', minWidth: 100 },
      ],
      columns: [
        { type: 'selection', width: 52 },
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.subcolumns,
              data: params.row.subData,
            },
          }),
        },
        { title: '开票日期', key: 'invoiceDate', minWidth: 116 },
        { title: '患者姓名', key: 'patientName', minWidth: 116 },
        { title: '发票金额', key: 'amount', minWidth: 116 },
        { title: '不含税金额', key: 'amountWithoutTax', minWidth: 130 },
        { title: '税额', key: 'tax', minWidth: 116 },
        {
          title: '发票类型', key: 'invoiceTypeName', minWidth: 116, tooltip: true, // 待确认字段
        },
        {
          title: '发票号', key: 'code', minWidth: 116, tooltip: true,
        },
        {
          title: '业务单据号',
          key: 'saleCode',
          minWidth: 136,
          render: (h, params) => {
            if (params.row.saleCode.length > 11) {
              return h('Tooltip', {
                props: {
                  placement: 'bottom',
                  content: params.row.saleCode,
                  maxWidth: 310,
                  wordBreak: 'break-all',
                },
              }, [
                h('p', {
                  style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100px',
                  },
                }, params.row.saleCode),
              ]);
            }
            return h('p', {
              style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100px',
              },
            }, params.row.saleCode);
          },
        },
        { title: '状态', key: 'status', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            (this.handlePermission('invoiceCheck')) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'invoiceCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('invoiceEdit') ? h('lk-button', {
              props: {
                type: 'text',
                disabled: params.row.status == '已完结',
                size: 'small',
              },
              on: {
                click: () => {
                  console.log(params);
                  this.$router.push({ name: 'invoiceEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,
    };
  },
  methods: {
    handleExport() { // 预留对接
      const { params } = this;
      if (params.invoiceTimeRange && params.invoiceTimeRange[1]) {
        params.invoiceDateStart = new Date(new Date(params.invoiceTimeRange[0]).toLocaleDateString()).getTime();
        params.invoiceDateEnd = (new Date(params.invoiceTimeRange[1])).getTime();
      }
      delete params.page;
      delete params.size;

      params.queryCondition = utils.getQueryCondition('.queryContainer');
      finance.downloadFinanceInvoiceList(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSelected(val) {
      this.invoiceFinishIds = [];
      val.forEach((item) => {
        this.invoiceFinishIds.push(item.id);
      });
    },
    cancelFinish() {
      this.finishModal = false;
    },
    handleFinish() {
      this.finishModal = true;
    },
    confirmFinish() {
      // 去掉已存在的项
      const financeInvoiceIdList = [];
      this.invoiceFinishIds.forEach((item) => {
        if (!this.invoiceFinishedIds.includes(item)) {
          financeInvoiceIdList.push(item);
        }
      });
      console.log(financeInvoiceIdList);
      finance.finishInvoice({ financeInvoiceIdList }).then((res) => {
        if (res.data.status === 200) {
          this.finishModal = false;
          this.handleSearch();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        invoiceTimeRange: [],
        invoiceCode: '',
        orderCode: '',
        status: '',
        nameMix: '',
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.invoiceTimeRange && this.params.invoiceTimeRange[1]) {
        this.params.invoiceDateStart = new Date(new Date(this.params.invoiceTimeRange[0]).toLocaleDateString()).getTime();
        this.params.invoiceDateEnd = (new Date(this.params.invoiceTimeRange[1])).getTime();
      }
      // console.log(this.params);
      finance.getInvoiceList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          console.log(res);
          res.data.data.list.forEach((item) => {
            if (item.financeInvoice) {
              item.id = item.financeInvoice.id;
              item.storeName = item.financeInvoice.storeName;
              item.invoiceDate = utils.exchangeTime(item.financeInvoice.invoiceDate);
              item.amount = item.financeInvoice.amount;
              item.amountWithoutTax = item.financeInvoice.amountWithoutTax;
              item.tax = item.financeInvoice.tax;
              item.code = item.financeInvoice.code;
              item.patientName = item.financeInvoice.patientName;
              item.invoiceTypeName = item.financeInvoice.invoiceTypeName;
              item.saleCode = '';
              item.subData = [];
            }
            if (item.financeInvoice.status === 2) {
              item.status = '已完结';
              // item._checked = true;
              item._disabled = true;
              this.invoiceFinishedIds.push(item.id);
            } else {
              item.status = '未完结';
            }
            if (item.financeInvoiceDetailVoList) {
              item.financeInvoiceDetailVoList.forEach((detail) => {
                const resultItem = {};
                utils.exchangeTable(detail, resultItem);
                if (resultItem.goodsInfoVoIsDtp === 1) {
                  resultItem.isDtp = '是';
                } else if (resultItem.goodsInfoVoIsDtp === 2) {
                  resultItem.isDtp = '否';
                }
                item.subData.push(resultItem);
                if (item.saleCode) {
                  item.saleCode = `${item.saleCode},${detail.financeInvoiceDetail.referCode}`;
                } else {
                  item.saleCode = detail.financeInvoiceDetail.referCode;
                }
              });
            } else item._disabled = true;
            item.saleCode += '';
            this.tableData.push(item);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(4, 0, {
        title: '门店', key: 'storeName', minWidth: 116, tooltip: true,
      });
    }
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .btns{
    margin-bottom: 12px;
    >*{
      margin-right: 16px
      }
    }
</style>
